<template>
    <div>
        <formSO 
            v-if="selectedSO.AllocationStatus!=8"
            :territoryCode="territory.code" 
            :selectedTerritory="territory" 
            :selectedDistChannel="customerCategory" 
            :selectedSalesChannel="salesChannel" 
            :territoryId="territory.id" 
            :selectedSO="selectedSO" 
            :optionTerritory="optionTerritory" 
            :redirectFrom="redirectFrom"
            :IsCancel="IsCancel"
            v-on:selectSalesOrder="updateSelectedSalesOrder"
            @successSave="changeTab"
            @redirectTab="redirectTab"
        ></formSO>
        <formSOManual 
            v-else-if="selectedSO.AllocationStatus==8"
            :territoryCode="territory.code" 
            :selectedTerritory="territory" 
            :selectedDistChannel="customerCategory" 
            :selectedSalesChannel="salesChannel" 
            :territoryId="territory.id" 
            :selectedSO="selectedSO" 
            :optionTerritory="optionTerritory" 
            :redirectFrom="redirectFrom"
            :IsCancel="IsCancel"
            v-on:selectSalesOrder="updateSelectedSalesOrder"
            @successSave="changeTab"
            @redirectTab="redirectTab"
        ></formSOManual>
        <span v-else></span>
    </div>
</template>

<script>
import formSO from "./form.vue";
import formSOManual from "./form_manual.vue";

export default {
    components: {
        formSO,
        formSOManual,
    },
    props: [
      "territoryCode", "territoryId", "selectedSO", "optionTerritory", "selectedTerritory", "selectedDistChannel", "selectedSalesChannel", "redirectFrom", "IsCancel"
    ],
    mounted() {
        console.log("this.selectedSO", this.selectedSO)
        console.log("this.$userLogin", this.$userLogin)
        this.$vs.loading();
        this.$vs.loading.close();
    },
    data: () => ({
        doFilter: 0,
        tabColor:['success', 'primary', 'warning', 'rgb(62, 201, 214)', 'success', 'rgb(62, 201, 214)'],
        dateStart: new Date(),
        dateEnd: new Date(),
        isAdmin:false,
        listSource:[
            {
                id:-1,
                name: "ALL",
                source:""
            },
            {
                id:0,
                name: "SFA",
                source:"sfa-mobile"
            },
            {
                id:1,
                name: "Back Office",
                source:"sfa-web"
            },
            {
                id:2,
                name: "Auto-Pool",
                source:"ext-json"
            },
            {
                id:3,
                name: "CMI",
                source:"cmi"
            }
        ],
        listOrderTypes:[{
            id:-1,
            name: "ALL",
            code:""
        }],
        selectedSources:[{
            id:-1,
            name: "ALL",
            source:""
        }],
        selectedOrderTypes:[{
            id:-1,
            name: "ALL",
            code:""
        }],
        
        cbdTypeFilter:[],

        tabIndex: 0,
        territory: {},
        optionTerritory: [{}],
        AlloptionTerritory: [{}],
        salesChannel: {},
        AlloptionSalesChannel:[{}],
        optionSalesChannel:[{}],
        customerCategory: {},
        optionCustomerCategory:[{}],
        AlloptionCustomerCategory:[{}],
        salesPersonal: {},
        optionSalesPersonal:[{}],
        AllOptionSalesPersonal:[{}],
        colorx: "success",
        selectedSO: {},
        showFilters: true,
        showFilterTerr: true,
        showFilterSc: false,
        showFilterDc: true,
        showFilterSales: true,
        isLoadingSales: false,
        redirectFrom: '',
        IsCancel: 0,
        searchSales: "",
    }),
    watch: {
        customerCategory: function() {
            console.log("this.customerCategory", this.customerCategory);
            if(this.customerCategory.name == 'All'){
                
            }
        },
        territory: function() {
            if(this.salesPersonal.Name == 'All' && this.salesPersonal.ID == undefined){
                this.getOptionSalesID().then(r => {
                    console.log(r);
                });
            }
        },
        salesChannel: function() {
            if(this.salesPersonal.Name == 'All' && this.salesPersonal.ID == undefined){
                this.getOptionSalesID().then(r => {
                    console.log(r);
                });
            }
        },
        salesPersonal: function() {
            if(this.salesPersonal.Name != 'All' && this.salesPersonal.SalesChannelId != 0){
                this.salesChannel = this.optionSalesChannel.filter((v) => {
                    return v.ID == this.salesPersonal.SalesChannelId;
                });
                this.salesChannel = this.salesChannel[0];
            }
        },
    },
    methods: {
        getOneDataByID(so_id,debug) {
            this.$vs.loading();
            this.$http.get("/api/v1/sales-order-mix2", {
                params: {
                    sales_order_id:so_id,
                }
            }).then(resp => {
                this.$vs.loading.close();
                console.log("test bossku=>",resp.data.SalesOrders)
                if (resp.data.SalesOrders&&resp.data.SalesOrders.length>0) {
                    this.$vs.loading();
                    this.updateSelectedSalesOrder(resp.data.SalesOrders[0])
                    if (debug=="true") {
                        this.redirectTab(3,'debug','All')
                    }else{
                        this.redirectTab(3,'monitoring','All')
                    }
                    this.$vs.loading.close();
                }
                if (resp.code == 200) {
                    
                } else {
                    this.$vs.notify({
                        color: "danger",
                        title: "Error",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle"
                    });
                }
            });
        },
        handleFilters(){
            this.doFilter++;
            console.log("this.doFilter", this.doFilter)
            console.log("this.territory", this.territory)
            console.log("this.salesChannel", this.salesChannel)
            console.log("this.customerCategory", this.customerCategory)
            console.log("this.salesPersonal", this.salesPersonal)
            console.log("this.source", this.selectedSource)
            console.log("this.dateStart", this.dateStart)
            console.log("this.dateEnd", this.dateEnd)
            console.log("this.SelectedOrderTypes", this.selectedOrderTypes  )
        },
        changeTab(index) {
            // console.log("before", this.tabIndex);
            // back to tab new SO
            this.$emit("successSave", index)
            this.$emit("redirectTab", index, '')
            
            console.log("idx", index);
            this.tabIndex = index;
            this.colorx = this.tabColor[index];
            if(index == 3) {
                window.scrollTo(0,0);
                this.showFilters        = false;
                this.showFilterTerr     = false;
                this.showFilterSc       = false;
                this.showFilterDc       = false;
                this.showFilterSales    = false;
                // this.showFilterStatus   = false;
            } else {
                this.showFilters        = true;
                this.showFilterTerr     = true;
                this.showFilterSc       = false;
                this.showFilterDc       = true;
                this.showFilterSales    = true;
                // this.showFilterStatus   = true;
            }
        },
        getOptionTerritory() {
            return new Promise((resolve, reject) => {
                this.$http.get("/api/v1/master/multiple-territory").then(resp => {
                    if(resp.code == 200){
                        this.optionTerritory = []
                        if (resp.data.is_admin || (this.$userLogin.territory == "" && this.$userLogin.territory_id == 0)){
                            this.optionTerritory.push({code:'All'})
                        }
                        for(var ter = 0; ter<resp.data.records.length; ter++){
                            this.optionTerritory.push(resp.data.records[ter])
                        }
                        if (this.optionTerritory.length>0) {
                            this.territory = this.optionTerritory[0];
                        }
                        this.AlloptionTerritory = this.optionTerritory;
                        resolve(true)
                    }else{
                        this.$vs.loading.close();
                        reject(false)
                        // this.$router.push("/");
                    }
                });
            });
        },
        getOptionSalesChannel() {
            return new Promise((resolve, reject) => {
                let url = "/api/v1/sales-channel/list";
                this.$http.get(url).then(
                  resp => {
                    // console.log("3039",resp)
                    if(resp.code == 200){
                      this.optionSalesChannel = []
                      this.optionSalesChannel.push({code:'All'})
                      for(var salesChannel = 0; salesChannel<resp.data.length; salesChannel++){
                        this.optionSalesChannel.push(resp.data[salesChannel])
                      }
                      this.AlloptionSalesChannel = this.optionSalesChannel;
                      this.salesChannel = this.optionSalesChannel[0];
                      console.log("resolve 3 lho - 1040")
                      resolve(true)
                    }else{
                      // this.$router.push("/");
                      console.log(resp);
                      reject(false)
                    }
                  }
                );
              });
        },
        getOptionCustomerCategory() {
            // this.$http.get("/api/v1/master/customer-category-all").then(
            // this.$http.get("/api/v1/master/customer-category-all").then(
            //     resp => {
            //         if(resp.code == 200){
            //             this.optionCustomerCategory = []
            //             this.optionCustomerCategory.push({name:'All'})
            //             for(var customerCategory = 0;customerCategory<resp.data.length;customerCategory++){
            //                 this.optionCustomerCategory.push(resp.data[customerCategory])
            //             }
            //             this.customerCategory = this.optionCustomerCategory[0];
            //             this.AlloptionCustomerCategory = this.optionCustomerCategory;
            //         }else{
            //             // this.$vs.loading.close();
            //             this.$router.push("/");
            //         }
            //     }
            // );
            return new Promise((resolve, reject) => {
                this.$http.get("/api/v1/master/customer-category-all").
                then(resp => {
                    if(resp.code == 200){
                        this.optionCustomerCategory = []
                        this.optionCustomerCategory.push({name:'All'})
                        for(var customerCategory = 0;customerCategory<resp.data.length;customerCategory++){
                            this.optionCustomerCategory.push(resp.data[customerCategory])
                        }
                        this.customerCategory = this.optionCustomerCategory[0];
                        this.AlloptionCustomerCategory = this.optionCustomerCategory;
                        resolve(true)
                    }else{
                      reject(false)
                    }
                  }
                );
            });
        },
        getOptionSalesID() {
            console.log("this.territory",this.territory)
            console.log("this.salesChannel",this.salesChannel)
            return new Promise((resolve, reject) => {
                this.isLoadingSales = true
                let territory_id = (this.territory.code != 'All' && this.territory.id) ? this.territory.id : 0;
                let sales_channel_id = this.salesChannel.code != 'All' ? this.salesChannel.ID : 0;
                this.$http.get("/api/v1/sales-order/personals",{
                    params: {
                      search: this.searchSales,
                      territory_id: territory_id,
                      sales_channel_id: sales_channel_id,
                    }
                }).then(resp => {
                    if(resp.code == 200){
                        this.optionSalesPersonal = []
                        this.optionSalesPersonal.push({Name:'All'})
                        let data = resp.data.salesman
                        for(var idx = 0;idx<data.length;idx++){
                            this.optionSalesPersonal.push(data[idx])
                        }
                        if (this.searchSales == ""){
                            this.salesPersonal = this.optionSalesPersonal[0];
                        }
                        console.log("resolve 5 lho - 1151")
                        this.isLoadingSales = false
                        resolve(true)
                    } else {
                      reject(false)
                    }
                  }
                );
            });
        },
        handlerSearchSales(search){
            this.searchSales = search
            if(search != ""){
                this.getOptionSalesID();
            }
        },

        updateSelectedSalesOrder(salesOrder, progress) {
            this.selectedSO = salesOrder;
            this.changeTab(3);
            console.log("selected", this.selectedSO);
            console.log("progress", progress);
            this.IsCancel = this.selectedSO.IsCancel;
        },
        redirectTab(index, from, progress) {
            this.$refs.tabs.activeChild(index);            
            this.redirectFrom = from;
            console.log("from", from);
            console.log("progress", progress);
            if(progress == 'cancel' || this.selectedSO.IsCancel == 1) {
                this.IsCancel = 1;
            } else {
                this.IsCancel = 0;
            }
            console.log("this.IsCancel", this.IsCancel);
        },
        handleSelectSource(v) {
            if (v.length > 0 && v[v.length-1].id == -1) {
                this.selectedSources = this.selectedSources.filter((v)=>{
                    return v.id ==-1
                })
            }else{
                this.selectedSources = this.selectedSources.filter((v)=>{
                    return v.id !=-1
                })
            }
        },
        getListSelectOrderType(){
            this.$http.get("/api/v1/master/sales-order-type", {
                params: {
                    order: 'name',
                    sort: 'asc',
                }
            }).then(resp => {
                console.log("order type bro",resp)
                if (resp.data.records.length>0) {
                    resp.data.records.forEach((el)=>{
                        if (el.Code =='ZDCBD') {
                            this.cbdTypeFilter.push({
                                id:el.ID,
                                name:el.Name,
                                code:el.Code,
                            })
                            // SO Cbd juga ditampilkan di tracker, maka opsi ZDCBD juga ditampilkan di filter
                            this.listOrderTypes.push({
                                id:el.ID,
                                name:el.Name,
                                code:el.Code,
                            })
                        }else{
                            this.listOrderTypes.push({
                                id:el.ID,
                                name:el.Name,
                                code:el.Code,
                            })
                        }
                    })
                }
            });
        },
        handleSelectOrderType(v){
            console.log("selectedOrderTypes",this.selectedOrderTypes)
            if (v.length > 0 && v[v.length-1].id == -1) {
                this.selectedOrderTypes = this.selectedOrderTypes.filter((v)=>{
                    return v.id ==-1
                })
            }else{
                this.selectedOrderTypes = this.selectedOrderTypes.filter((v)=>{
                    return v.id !=-1
                })
            }
        },
        setAsNewSo(salesOrder, progress) {
            this.$vs.loading();
            console.log("salesOrder", salesOrder)
            console.log("progress", progress)

            // let baseUrl = "/api/v3/sales-order/set_as_newso/" + salesOrder.DefaultAttribute.ID;
            let baseUrl = "/api/v3/sales-order/set_as_newso/" + salesOrder.ID;

            this.$http.put(baseUrl).then((resp) => {
                console.log(resp)
                this.$vs.loading.close();
                if (resp.code == 200) {
                    this.$vs.notify({
                        color: "success",
                        title: "Success",
                        text: resp.message,
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-check-circle",
                    });
                    this.redirectTab(0,'monitoring','All')
                } else {
                    this.$vs.notify({
                        title: "Error",
                        text: resp.message,
                        color: "danger",
                        position: "top-right",
                        iconPack: "feather",
                        icon: "icon-x-circle"
                    });
                }
            });
        },
    }
};
</script>

<style scoped>
.vs-collapse-item--content {
  height: 100%;
  max-height: 14444px;
}
</style>